import { render } from "./Link.vue?vue&type=template&id=02717326"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
script.render = render

export default script